// components/CommonModal.jsx
import React from 'react';
import PropTypes from 'prop-types';

export default function CommonModal({
  isOpen,
  onClose = () => { },
  title = '',
  children,
  size = 'max-w-3xl',
  showCloseIcon = true,
  footer = null,
  closeOnOutsideClick = true,
}) {
  if (!isOpen) return null;

  const handleBackgroundClick = (e) => {
    if (e.target === e.currentTarget && closeOnOutsideClick) {
      onClose();
    }
  };

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40"
      onClick={handleBackgroundClick}
    >
      <div className={`bg-white rounded-xl w-[95%] ${size} shadow-lg max-h-[90vh] overflow-hidden`}>
        {/* Header */}
        <div className="flex justify-between items-center px-6 py-4 border-b">
          <h2 className="text-xl font-semibold">{title}</h2>
          {showCloseIcon && (
            <button onClick={onClose} className="text-gray-500 hover:text-gray-700 text-2xl">
              ×
            </button>
          )}
        </div>

        {/* Body */}
        <div className="p-6 overflow-y-auto max-h-[65vh]">{children}</div>

        {/* Footer */}
        {footer && <div className="px-6 py-4 border-t bg-gray-50">{footer}</div>}
      </div>
    </div>
  );
}

// Prop types for better validation
CommonModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  title: PropTypes.string,
  children: PropTypes.node.isRequired,
  size: PropTypes.string,
  showCloseIcon: PropTypes.bool,
  footer: PropTypes.node,
  closeOnOutsideClick: PropTypes.bool,
};
